module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    ref: "modal",
    attrs: {
      "showOnCreate": _vm.showOnCreate,
      "title": _vm.modalTitle,
      "width": _vm.isNewAudienceStep ? 600 : 0,
      "closeButton": "",
      "hideActions": !_vm.showButtons
    },
    on: {
      "closed": _vm.destroySetup,
      "exited": _vm.destroySetup
    }
  }, [(!_vm.isDataStep && !_vm.isDuplicate && !_vm.isUpdate && !_vm.isUpdateCampaign && !_vm.isViewingSegmentInfo && _vm.showBackButton) ? _c('template', {
    slot: "header-buttons"
  }, [(!_vm.isNewAudienceStep) ? _c('back-arrow-nav', {
    staticClass: "las-back-button",
    on: {
      "goBack": _vm.goBack
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "stepper"
  }, [(_vm.isDataStep) ? _c('data-source-step', {
    attrs: {
      "targetName": _vm.titleInfo.targetName
    },
    model: {
      value: (_vm.dataInfo),
      callback: function($$v) {
        _vm.dataInfo = $$v
      },
      expression: "dataInfo"
    }
  }) : (_vm.isFinishStep) ? _c('finish-step', {
    attrs: {
      "targetName": _vm.titleInfo.targetName,
      "selectedDataSource": _vm.selectedDataSource,
      "onComplete": _vm.stepperOnComplete
    },
    on: {
      "close": _vm.close
    },
    model: {
      value: (_vm.finishInfo),
      callback: function($$v) {
        _vm.finishInfo = $$v
      },
      expression: "finishInfo"
    }
  }) : (_vm.isNewAudienceStep) ? _c('create-audience', {
    attrs: {
      "onComplete": _vm.stepperOnComplete,
      "onAudienceActivation": _vm.onAudienceActivation
    },
    model: {
      value: (_vm.audienceInfo),
      callback: function($$v) {
        _vm.audienceInfo = $$v
      },
      expression: "audienceInfo"
    }
  }) : _vm._e()], 1)], _vm._v(" "), (_vm.showButtons) ? _c('template', {
    slot: "actions"
  }, [_c('action-button', {
    attrs: {
      "disabled": _vm.disableBackButton,
      "label": "cancel",
      "color": "secondary",
      "id": "datasourceModalCancelBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelButton.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "disabled": !_vm.completedCurrentStep,
      "label": "Next",
      "color": "success",
      "id": "datasourceModalNextBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextButton.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b3290f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/stepper/StepperModal.vue
// module id = 1887
// module chunks = 0